import {Routes} from '@angular/router';

export const goodsDetailImgManagementRoutes: Routes = [
      {
        path: 'serviceGoodsDetailImgManagement',
        loadComponent: () => import('./goods-detail-img-management.component').then(m => m.GoodsDetailImgManagementComponent),
        data: { title: '详情页图片' },
      },
];
